// extracted by mini-css-extract-plugin
export default {"record":"b3qPybMOxJxST0m8OHcP","row":"WkMtR5r_q4lcxUus0P8l"};